var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.195,
    height: 80.39,
    viewBox: "0 0 72.195 80.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "package_2_",
    "data-name": "package(2)",
    transform: "translate(-2 -0.91)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 35.098,
    y1: 20.24,
    transform: "translate(20.549 10.612)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M73.2,56.59v-31.2a7.8,7.8,0,0,0-3.9-6.747L42,3.047a7.8,7.8,0,0,0-7.8,0L6.9,18.646A7.8,7.8,0,0,0,3,25.392v31.2a7.8,7.8,0,0,0,3.9,6.747l27.3,15.6a7.8,7.8,0,0,0,7.8,0l27.3-15.6A7.8,7.8,0,0,0,73.2,56.59Z",
    transform: "translate(0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M3.27,6.96,37.315,26.654,71.359,6.96",
    transform: "translate(0.783 14.377)",
    fill: "rgba(0,0,0,0)",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    y1: 39.309,
    transform: "translate(38.098 40.991)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.614fad93ab4342023865a43728ef91ce.svg";
export { ForwardRef as ReactComponent };